module.exports = __webpack_public_path__ + "img/swissquote.b63a0ece.png";